import { CircleAlertIcon, CircleCheckIcon } from 'lucide-react';

import { AnalysisSubHeader } from '../../../components';
import { TintedListCard } from './TintedListCard';
import { useTranslation } from 'react-i18next';

interface CurrentPerformanceAssessmentProps {
  strengths?: string[];
  weaknesses?: string[];
}

export const CurrentPerformanceAssessment = ({
  strengths,
  weaknesses,
}: CurrentPerformanceAssessmentProps) => {
  const { t } = useTranslation('analysis');

  if (!strengths?.length && !weaknesses?.length) return null;

  return (
    <div className="flex flex-col gap-6">
      <AnalysisSubHeader
        title={t('analysisResult.currentPerformanceAssessment.currentPerformanceAssessment')}
        subtitle={t('analysisResult.currentPerformanceAssessment.strengthsToPressAndGapsToClose')}
        subtitleTone="meta"
      />
      <div className="grid grid-cols-1 items-stretch gap-3 md:grid-cols-2">
        {strengths && strengths.length > 0 && (
          <TintedListCard
            tone="positive"
            icon={CircleCheckIcon}
            title={t('analysisResult.currentPerformanceAssessment.whatWeReDoingWell')}
            items={strengths}
          />
        )}
        {weaknesses && weaknesses.length > 0 && (
          <TintedListCard
            tone="destructive"
            icon={CircleAlertIcon}
            title={t('analysisResult.currentPerformanceAssessment.areasForImprovement')}
            items={weaknesses}
          />
        )}
      </div>
    </div>
  );
};
